<template>
    <div class="Filters">
        <div class="Filters--wrapper">
            <div class="Filters--wrapper-days mt-3">
                <label class="mr-2">Days</label>
                <div class="Filters--wrapper-days-layout">
                    <div :class="['Filters--wrapper-days-layout-day', { 'day-selected': day.selected }]"
                         v-for="day of week"
                         @click="selectDay(day)"
                    >
                        {{ day.name.slice(0,3) }}
                    </div>
                </div>
            </div>

            <filter-list
                    class="w-auto mr-2 mt-3"
                    height="40px"
                    label="Ages"
                    :data-list="agesList"
                    @update:checked="onAgeChecked"
            />
            <filter-list
                    class="w-auto mr-2 mt-3"
                    height="40px"
                    :label="schoolCountry === 'England' ? 'Years' : 'Grade'"
                    :data-list="gradesList"
                    @update:checked="onGradeChecked"
            />
            <filter-list
                    class="w-auto mr-2 mt-3"
                    height="40px"
                    label="Locations"
                    :data-list="locationsList"
                    @update:checked="onLocationChecked"
            />
        </div>

        <button class="Filters--btn social-button mt-3 "
                @click.prevent="resetFilterOptions"
        >
            Clear filter
        </button>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import { mapGetters, mapActions } from 'vuex';
    import { GRADES } from '@/constants/grades';
    import { AGES } from '@/constants/school-ages';
    import { DAYS } from '@/constants/dates';

    export default {
        name: 'Filters',

        components: {
            SelectBox: () => import('@/components/controls/SelectBox'),
            FilterList: () => import('@/components/controls/FilterList'),
        },

        props: {
            callback: {
                type: Function,
                default: () => {}
            }
        },

        data() {
            return {
                week: DAYS.map(el => {
                    return {
                        name: el,
                        selected: true
                    }
                }),
                grades: GRADES,
                ages: AGES
            }
        },

        computed: {
            ...mapGetters(['locations', 'filters', 'schoolCountry']),

            agesList() {
                return this.ages.map(age => ({
                    title: age.view,
                    id: age.data,
                    checked: this.filters.ages[age.data]
                }))
            },

            gradesList() {
                return this.grades && this.grades.map(grade => ({
                    title: grade.view,
                    id: grade.info,
                    checked: this.filters.grades[grade.info]
                }))
            },

            locationsList() {
                return this.locations && this.locations.map(location => ({
                    title: location.name,
                    id: location.id,
                    checked: this.filters.locationIds[location.id]
                }))
            },
        },

        methods: {
            ...mapActions(['updateFilterDropdown', 'resetFilters', 'updateFilterDay']),

            selectDay(day) {
                day.selected = !day.selected;

                for (const key in this.filters) {
                    if (_.lowerCase(day.name) === key) {
                        this.filters[key] = day.selected;
                        this.updateFilterDay(this.filters);
                    }
                }
            },

            onAgeChecked({ option, checked }) {
                const age = this.ages.find(age => age.view === option).data;
                this.updateFilterDropdown({field: 'ages', property: age, checked});
            },

            onGradeChecked({ option, checked }) {
                const grade = this.grades.find(grade => grade.view === option).info;
                this.updateFilterDropdown({field: 'grades', property: grade, checked});
            },

            onLocationChecked({ option, checked }) {
                const location = this.locations.find(location => location.name === option).id;
                this.updateFilterDropdown({field: 'locationIds', property: location, checked});
            },

            async resetFilterOptions() {
                Object.assign(this.$data, this.$options.data());
                await this.resetFilters();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .Filters {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 30px;

        &--wrapper {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            &-days {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                &-layout {
                    display: flex;
                    justify-content: space-between;

                    &-day {
                        height: 40px;
                        width: 100%;
                        min-width: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                        border-radius: 2px;
                        cursor: pointer;
                        font-size: 11px;
                        color: $ShoppingCartTextColor;
                        background-color: $ComplementaryBgTxtDarker;

                        @media screen and (max-width: 900px) {
                            height: 35px;
                            width: 35px;
                        }

                        @media screen and (max-width: 425px) {
                            height: 35px;
                            width: 35px;
                            margin-top: 5px;
                            margin-right: 9px;
                        }
                    }

                    .day-selected {
                        color: $White;
                        background-color: $Violet;

                        @media screen and (max-width: 900px) {
                            justify-content: center;
                        }
                    }
                }
            }
        }

        &--btn {
            height: 40px;
            max-width: 10%;
            min-width: 100px;
            background-color: #f7f8f9;

            @media screen and (max-width: 900px) {
                max-width: 20%;
            }

            @media screen and (max-width: 768px) {
                max-width: 30%;
            }

            @media screen and (max-width: 425px) {
                max-width: 40%;
            }
        }
    }

    /deep/ .form-group {
        margin-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/Filters.vue